import React, { useState } from "react";
import { SignupSlide } from "./AuthComponent";
import { useNavigate } from "react-router";
import { UserApi } from "../../app/api/user.api";
import './Login.css';


export function Signup() 
{   
    const navigate = useNavigate();
    const user = UserApi();
    
    const [inputs, setInputs] = useState();
    const [status, setStatus] = useState(0);
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword1, setShowPassword1] = useState(false);
    const [checked, setChecked] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);


    const handleInputs = ( event ) => {
      const { name , value } =  event.target;
      setInputs( { ...inputs, [name] : value   } );
    }


    const handleSubmit = async ( event ) => {
      
      event.preventDefault();
      setStatus(0);
      setIsLoading(true);
        
      if(inputs.password === inputs.confirmPassword )
      {   
          try {
              const {data} = await user.insert(inputs);
              setIsLoading(false);
              if(data.success){
                  setStatus(1);
                  setIsSubmitted(true);
              }  
              else{ 
                  setStatus(-1);
                  setMessage('Erreur, veuillez réessayer'); 
                  setIsSubmitted(false);
              } 
          } catch (err) { 
              setIsLoading(false);
              setStatus(-1); 
              setIsSubmitted(false);
              
              const response = err?.response?.data;

              if (response?.message) {
                setMessage(response.message);
              } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
                setMessage(response.errors[0].msg || response.errors[0]);
              } else {
                setMessage("Une erreur est survenue. Veuillez réessayer.");
              }
          }
      }
      else{ 
          setIsLoading(false);
          setStatus(-2); 
      }
    } 


    const [resendMessage, setResendMessage] = useState("");
    const [resendStatus, setResendStatus] = useState(0);
    const [resendLoading, setResendLoading] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const handleResendEmail = async () => {
      setResendLoading(true);
      setResendStatus(0);
      try {
        const { data } = await user.updateEmail({ email: inputs.email });
        setResendLoading(false);
        if (data.success) {
          setResendStatus(1);
          setIsButtonDisabled(true);
          setResendMessage("Email de confirmation renvoyé avec succès.");
        } else {
          setResendStatus(-1);
          setResendMessage("Erreur lors du renvoi de l'email. Veuillez réessayer.");
        }
      } catch (err) 
      {
        setResendLoading(false);
        setResendStatus(-1);
        const response = err?.response?.data;

        if (response?.message) {
          setResendMessage(response.message);
        } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
          setResendMessage(response.errors[0].msg || response.errors[0]);
        } else {
          setResendMessage("Une erreur est survenue. Veuillez réessayer.");
        }
      }
      finally {
        setTimeout(() => {
          setResendStatus(0);
          setResendMessage("");
          setIsButtonDisabled(false);
        }, 30000);
      }
    }

    return(

        <div className="container-fluid">
          <div className="row justify-content-center align-items-center" style={{minHeight: '100vh', backgroundColor: '#f5f5f5'}}>
            <div className="col-lg-10 col-md-11 col-sm-12">

                <section className="hottest-deals-container container-fluid px-0 border bg-light">
                  <div className="row g-0">

                    {/* Colonne de gauche : Contenu Textuel (Le Slider) */}
                    <SignupSlide />

                    {/* Colonne de droite : Image */}
                    <div className="col-md-7 py-5 order-1 order-md-2">
                      <div className="row justify-content-center">
                        <div className="col-sm-10 col-11">

                           <div className="d-flex mb-4">
                              <button onClick={() => navigate(-1)} className='btn btn-sm btn-outline-dark'> <i className="bi bi-chevron-left"></i> Retour </button>
                           </div>

                           { !isSubmitted ? (

                            <form className="d-flex flex-column" onSubmit={ handleSubmit }>

                              <div className="d-flex">
                                  <span className="d-flex bg-green p-1 rounded mb-3">
                                    <div className="d-flex bg-light-gray rounded justify-content-center w-100 pt-2 pb-1 px-4">
                                        <span className="h4 text-secondary"> Inscription Ortega </span>
                                    </div>
                                  </span>
                              </div>

                              <div className="d-flex justify-content-center">
                                {
                                  isLoading && (
                                    <div className="d-flex justify-content-center mb-2"> 
                                      <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
                                    </div>
                                  )
                                }
                                {
                                  status === -1 && (
                                    <div className="alert alert-danger mb-2 w-100 small"> { message }  </div>
                                  )
                                }
                                {
                                  status === -2 && (
                                    <div className="d-flex justify-content-center mb-2">
                                      <div className="alert alert-danger">
                                        Erreur! Veuillez revoir votre mot de passe et la confirmation.
                                      </div>
                                    </div>
                                  )
                                } 
                              </div>

                              <div className="d-flex flex-column mb-2">
                                  <label htmlFor="fname" className="small text-secondary ps-2"> Prénom </label>
                                  <input type="text" name="fname" className="input-field" id="fname" placeholder="Enter prénom" onChange={handleInputs} required />
                              </div>

                              <div className="d-flex flex-column mb-2">
                                 <label htmlFor="lname" className="small text-secondary ps-2"> Nom </label>
                                 <input type="text" name="lname" className="input-field" id="lname" placeholder="Enter nom" onChange={handleInputs} required />
                              </div>

                              <div className="d-flex flex-column mb-1">
                                 <label htmlFor="phone" className="small text-secondary ps-2"> Numéro de téléphone joignable </label>
                                 <input type="tel" name="phone" className="input-field" id="phone" placeholder="+212 77 000 00 0" onChange={handleInputs} required />
                              </div>

                              <div className="d-flex alert alert-success small mb-3 py-1">
                               Ce numéro nous permettra de vous joindre si nécessaire lors du traitement ou de la livraison de vos commandes. Veuillez bien remplir.
                              </div>

                              <div className="d-flex flex-column mb-2">
                                 <label htmlFor="email" className="small text-secondary ps-2"> Email </label>
                                 <input type="text" name="email" className="input-field" id="email" placeholder="Enter email" onChange={handleInputs} required />
                              </div>
                             
                              <div className="d-flex flex-column flex-sm-row w-100 gap-3 mb-3">
                                <div className="d-flex flex-column mb-2 w-100">
                                   <label htmlFor="password" className="small text-secondary ps-2"> Mot de passe </label>
                                   <div className="password-input-wrapper">
                                       <input type={showPassword ? 'text' : 'password'} name="password" id="password" className="input-field" placeholder="••••••••" onChange={handleInputs} required />
                                       <button type="button" className="toggle-password-btn" onClick={() => setShowPassword(!showPassword)} title={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'} >
                                         <i className={`bi bi-eye${!showPassword ? '-slash' : ''}`}></i>
                                       </button>
                                   </div>
                                </div>
                                <div className="d-flex flex-column mb-2 w-100">
                                   <label htmlFor="cpassword" className="small text-secondary ps-2"> Confirmer Mot de passe </label>
                                   <div className="password-input-wrapper">
                                       <input type={showPassword1 ? 'text' : 'password'} name="confirmPassword" id="cpassword" className="input-field" placeholder="••••••••" onChange={handleInputs} required />
                                       <button type="button" className="toggle-password-btn" onClick={() => setShowPassword1(!showPassword1)} title={showPassword1 ? 'Masquer le mot de passe' : 'Afficher le mot de passe'} >
                                         <i className={`bi bi-eye${!showPassword1 ? '-slash' : ''}`}></i>
                                       </button>
                                   </div>
                                </div>
                              </div>

                              <div className="d-flex gap-2 mb-3">
                                  <input type="checkbox" name="name" checked={checked} onChange={(e) => setChecked(e.target.checked)} style={{ width: '20px', height: '20px' }} />
                                  <span className="small text-secondary mb-1"> J'accepte les <a href="/condition-utilisation" target="_blank" className="active-link"> conditions d'utilisation <i className="bi bi-arrow-right"></i> </a> </span>
                              </div>
                              
                              {/* Login Button */}
                              <div className="d-flex">
                                <button type="submit" disabled={!checked} className="btn btn-green py-2 px-4">
                                  <span> S'inscrire </span>
                                  <i className="bi bi-chevron-right ms-2"></i>
                                </button>
                              </div>

                           </form>

                           ) : (
                               <div className="d-flex flex-column text-center px-4">
                                 <div className="mb-3">
                                   <i className="bi bi-check-circle text-green" style={{ fontSize: '3rem' }}></i>
                                 </div>
                                 <p className="text-secondary">
                                   Un email d'activation de compte a été envoyé à l'adresse : <strong> { inputs.email } </strong>
                                 </p>
                                 <p className="text-muted small">
                                   Vérifiez votre boîte de réception et suivez les instructions d'activation de votre compte utilisateur. Si vous ne voyez pas l'email, vérifiez votre dossier de spam ou de courrier indésirable.
                                 </p>
                                 <div className="mb-3 d-flex flex-column">
                                    {
                                      resendStatus === 1 &&  (
                                        <div className="d-flex flex-column">
                                          <span className="alert alert-success small py-1"> { resendMessage } </span>
                                          <span className="text-secondary text-x-small mt-2"> Veuillez patienter 30s avant de réessayer. </span>
                                        </div>
                                      )
                                    }
                                    {
                                      resendStatus === -1 && (
                                        <div className="d-flex flex-column">
                                          <span className="alert alert-danger small py-1"> { resendMessage } </span>
                                          <span className="text-secondary text-x-small mt-2"> Veuillez patienter 30s avant de réessayer. </span>
                                        </div>
                                      )
                                    }
                                 </div>
                                 <button className="btn btn-green py-2 px-4" onClick={handleResendEmail} disabled={resendLoading || isButtonDisabled}>
                                    { 
                                      resendLoading ? (
                                       <>
                                         <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                         Envoi en cours...
                                       </>
                                      ) : (
                                       <>
                                         <span>Renvoyer l'email</span>
                                         <i className="bi bi-chevron-right ms-2"></i>
                                       </>
                                      ) 
                                    }
                                 </button>
                               </div>
                           )
                          }
                        </div>
                      </div>
                    </div>

                  </div>
                </section>

            </div>
          </div>
        </div>
    );
}